import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/modal-window/modal-window.js';
      import {ObcModalWindowSize} from '@oicl/openbridge-webcomponents/dist/components/modal-window/modal-window.js';

      export interface Props {
     size?: ObcModalWindowSize;
     hasOptionalAction?: boolean;
     hasLeadingIcon?: boolean
   }

      
  
      export type {ObcModalWindowSize} from '@oicl/openbridge-webcomponents/dist/components/modal-window/modal-window.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcModalWindow',
  props: {
    size: {},
    hasOptionalAction: { type: Boolean },
    hasLeadingIcon: { type: Boolean }
  },
  emits: ["close-click", "cancel-click", "done-click", "option-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onCloseClick: (event: CustomEvent<unknown>) => emit('close-click', event as CustomEvent<unknown>),
onCancelClick: (event: CustomEvent<unknown>) => emit('cancel-click', event as CustomEvent<unknown>),
onDoneClick: (event: CustomEvent<unknown>) => emit('done-click', event as CustomEvent<unknown>),
onOptionClick: (event: CustomEvent<unknown>) => emit('option-click', event as CustomEvent<unknown>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-modal-window',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})